import React from "react";
import Box from "@mui/material/Box";

// The grab strip on the right edge of a header cell. Double-click returns that
// column to sizing itself, which is the way back out of a bad drag.
export default function ColumnResizer({ onStart, onReset, active }) {
  return (
    <Box
      role="separator"
      aria-orientation="vertical"
      aria-label="Cambiar el ancho de la columna"
      onPointerDown={onStart}
      onDoubleClick={onReset}
      onClick={(e) => e.stopPropagation()}
      sx={{
        position: "absolute",
        top: 0,
        right: -3,
        bottom: 0,
        width: 10,
        cursor: "col-resize",
        zIndex: 1,
        // Invisible until it is wanted: a line per column would turn the header
        // into a fence.
        "&::after": {
          content: '""',
          position: "absolute",
          top: 6,
          bottom: 6,
          left: 4,
          width: 2,
          borderRadius: 1,
          backgroundColor: active ? "primary.main" : "transparent",
        },
        "&:hover::after": { backgroundColor: "primary.main" },
        // Touch has no hover and no thin targets; dragging a 10px strip with a
        // finger is a miss, so the column widths stay a pointer feature.
        display: { xs: "none", md: "block" },
      }}
    />
  );
}
